import {
  SET_VISIBILITY_FILTER, RESET_VISIBILITY_FILTER,
  SET_SORT_KEY, RESET_SORT_KEY,
  SET_DIFFICULTY_FILTER, RESET_DIFFICULTY_FILTER,
  SET_TONALITY_FILTER, RESET_TONALITY_FILTER,
  SET_STATUS_FILTER, RESET_STATUS_FILTER,
  SET_TYPE_FILTER, RESET_TYPE_FILTER,
  SET_AUTHOR_FILTER, RESET_AUTHOR_FILTER, SET_AUTHOR_OPTIONS,
  SET_PERFORMER_FILTER, RESET_PERFORMER_FILTER, SET_PERFORMER_OPTIONS,
} from '../constants/filters';

export const setVisibilityFilter = filter => ({type: SET_VISIBILITY_FILTER, filter});
export const resetVisibilityFilter = () => ({type: RESET_VISIBILITY_FILTER});
export const setSortKey = key => ({type: SET_SORT_KEY, key});
export const resetSortKey = () => ({type: RESET_SORT_KEY});

export const setDifficultyFilter = filter => ({type: SET_DIFFICULTY_FILTER, filter});
export const resetDifficultyFilter = () => ({type: RESET_DIFFICULTY_FILTER});

export const setTonalityFilter = filter => ({type: SET_TONALITY_FILTER, filter});
export const resetTonalityFilter = () => ({type: RESET_TONALITY_FILTER});

export const setStatusFilter = filter => ({type: SET_STATUS_FILTER, filter});
export const resetStatusFilter = () => ({type: RESET_STATUS_FILTER});

export const setTypeFilter = filter => ({type: SET_TYPE_FILTER, filter});
export const resetTypeFilter = () => ({type: RESET_TYPE_FILTER});

export const setAuthorFilter = (filter) => ({type: SET_AUTHOR_FILTER, filter});
export const resetAuthorFilter = () => ({type: RESET_AUTHOR_FILTER});

export const setAuthorOptions = (visibleOffers) => {
  let authors = [];
  for (let offer of visibleOffers) {
      let exist = authors.find(a => a.pk === offer.author_id);
      if (exist){
        exist.count = exist.count + 1;
      } else {
        authors.push({'pk': offer.author_id, 'name': offer.author, 'count': 1});
      }
  };
  authors = authors.sort((a, b) => {
      a = a['name'];
      b = b['name'];
      return (a === b ? 0 : a > b ? 1 : -1)
  });
  return { type: SET_AUTHOR_OPTIONS, list: authors }
}

export const setPerformerFilter = (filter) => ({type: SET_PERFORMER_FILTER, filter});
export const resetPerformerFilter = () => ({type: RESET_PERFORMER_FILTER});

export const setPerformerOptions = (visibleOffers) => {
  let performers = [];
  for (let offer of visibleOffers) {
      let exist = performers.find(a => a.pk === offer.performer_id);
      if (exist){
        exist.count = exist.count + 1;
      } else {
        performers.push({'pk': offer.performer_id || 0, 'name': offer.performer, 'count': 1});
      }
  };
  performers = performers.sort((a, b) => {
      a = a['name'];
      b = b['name'];
      return (a === b ? 0 : a > b ? 1 : -1)
  });
  return { type: SET_PERFORMER_OPTIONS, list: performers }
}